import { RouteView } from "@/layouts";
export default {
  path: "/user",
  name: "user",
  redirect: "/user/index",
  component: RouteView,
  meta: {
    title: "个人中心",
    icon: "user-o",
    showNavBar: true,
  },
  children: [
    {
      path: "/user/index",
      name: "userIndex",
      component: () =>
        import(/* webpackChunkName: "user" */ "@/views/user/Index.vue"),
      meta: {
        title: "个人中心",
        showNavBar: true,
      },
    },
    {
      path: "/user/contact",
      name: "userContact",
      component: RouteView,
      meta: {
        title: "就诊人管理",
      },
      redirect: "/user/contact/list",
      children: [
        {
          path: "/user/contact/list",
          name: "userContactList",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/List.vue"),
          meta: {
            title: "就诊人列表",
          },
        },
        {
          path: "/user/contact/info",
          name: "userContactInfo",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/Info.vue"),
          meta: {
            title: "查看就诊人信息",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/edit",
          name: "userContactEdit",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/Edit.vue"),
          meta: {
            title: "编辑就诊人信息",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/addCard",
          name: "userContactAddCard",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/AddCard.vue"),
          meta: {
            title: "自助办理电子健康卡",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/CreatCardMenu",
          name: "userContactCreatCardMenu",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/CreatCardMenu.vue"),
          meta: {
            title: "办理健康卡",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/SignIn",
          name: "userContactSignIn",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/SignIn.vue"),
          meta: {
            title: "签到",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/ScreeningForm",
          name: "ScreeningForm",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/ScreeningForm.vue"),
          meta: {
            title: "流行病学筛查表",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/CheckScreeningForm",
          name: "CheckScreeningForm",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/CheckScreeningForm.vue"),
          meta: {
            title: "筛查记录",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/screeningForm/form",
          name: "screeningFormForm",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/screeningForm/Form.vue"),
          meta: {
            title: "调查表",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/screeningForm/query",
          name: "screeningFormQuery",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/screeningForm/Query.vue"),
          meta: {
            title: "筛查记录",
            showNavBar: false,
          },
        },
        {
          path: "/user/contact/ScreeningFormChooseContact",
          name: "ScreeningFormChooseContact",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/contact/ScreeningFormChooseContact.vue"),
          meta: {
            title: "选择就诊人",
            showNavBar: false,
          },
        },
      ],
    },
    {
      path: "/user/order",
      name: "userOrder",
      component: RouteView,
      meta: {
        title: "预约挂号管理",
      },
      redirect: "/user/order/list",
      children: [
        {
          path: "/user/order/list",
          name: "userOrderList",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/order/List.vue"),
          meta: {
            title: "预约挂号列表",
          },
        },
        {
          path: "/user/order/info",
          name: "userOrderInfo",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/order/Info.vue"),
          meta: {
            title: "预约详情",
            showNavBar: false,
          },
        },
      ],
    },
    {
      path: "/user/inHospital",
      name: "userInHospital",
      component: RouteView,
      meta: {
        title: "我的住院",
      },
      redirect: "/user/inHospital/Index",
      children: [
        {
          path: "/user/inHospital/Index",
          name: "userInHospitalIndex",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/inHospital/Index.vue"),
          meta: {
            title: "我的住院",
          },
        },
        {
          path: "/user/inHospital/recharge",
          name: "userInHospitalRecharge",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/inHospital/Recharge.vue"),
          meta: {
            title: "预交金充值",
            showNavBar: false,
          },
        },
        {
          path: "/user/inHospital/detailed",
          name: "userInHospitalDetailed",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/inHospital/Detailed.vue"),
          meta: {
            title: "住院费用汇总",
            showNavBar: false,
          },
        },
        {
          path: "/user/inHospital/detailed-info",
          name: "userInHospitalDetailedInfo",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/inHospital/DetailedInfo.vue"),
          meta: {
            title: "住院费用每日清单",
            showNavBar: false,
          },
        },
        {
          path: "/user/inHospital/summary",
          name: "userInHospitalSummary",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/inHospital/Summary.vue"),
          meta: {
            title: "住院信息",
            showNavBar: false,
          },
        },
        {
          path: "/user/inHospital/hospitalizationReport",
          name: "userInHospitalizationReport",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/inHospital/HospitalizationReport.vue"),
          meta: {
            title: "住院信息",
            showNavBar: false,
          },
        },
        {
          path: "/user/inHospital/info",
          name: "userInHospitalInfo",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/inHospital/Info.vue"),
          meta: {
            title: "检查报告明细",
          },
        },
        {
          path: "/user/inHospital/inspection-info",
          name: "userInHospitalInspectionInfo",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/inHospital/InspectionInfo.vue"),
          meta: {
            title: "检验报告明细",
          },
        },
      ],
    },
    {
      path: "/user/bill",
      name: "userBill",
      component: RouteView,
      meta: {
        title: "我的账单",
      },
      redirect: "/user/bill/list",
      children: [
        {
          path: "/user/bill/list",
          name: "userBillList",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/bill/List.vue"),
          meta: {
            title: "我的账单",
          },
        },
        {
          path: "/user/bill/info",
          name: "userBillInfo",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/bill/Info.vue"),
          meta: {
            title: "我的账单明细",
          },
        },
      ],
    },
    {
      path: "/user/report",
      name: "userReport",
      component: RouteView,
      meta: {
        title: "我的报告",
      },
      redirect: "/user/report/list",
      children: [
        {
          path: "/user/report/list",
          name: "userReportList",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/report/List.vue"),
          meta: {
            title: "我的报告",
          },
        },
        {
          path: "/user/report/info",
          name: "userReportInfo",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/report/Info.vue"),
          meta: {
            title: "检查报告明细",
          },
        },
        {
          path: "/user/report/inspection-info",
          name: "userReportInspectionInfo",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/user/report/InspectionInfo.vue"),
          meta: {
            title: "检验报告明细",
          },
        },
      ],
    },
    {
      path: "/electricBill/list",
      name: "electricBillList",
      showNavBar: false,
      component: () =>
        import(/* webpackChunkName: "electricBill" */ "@/views/electricBill/List.vue"),
      meta: {
        title: "我的电子票据",
        showNavBar: false,
      },
    },
  ],
};
